import { render, staticRenderFns } from "./settings-main.vue?vue&type=template&id=5244da5e&"
import script from "./settings-main.vue?vue&type=script&lang=js&"
export * from "./settings-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports